import { Injectable } from '@angular/core';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { ProdutoElement } from './core/models/produto';
import { FormGroup } from '@angular/forms';

@Injectable()
export class AppSharedDataService {

  score!: number;

  private showScore = new Subject<number>();
  showScore$ = this.showScore.asObservable();

  constructor() { }

  public setShowScore(data: number): void {
    this.showScore.next(data);
  }

  setScore(val: any) {
    this.score = val;
  }

  getScore() {
    return this.score;
  }
  private minimizeMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  minimizeMenu$ = this.minimizeMenu.asObservable();

  private buscar: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(new FormGroup({}));
  buscar$ = this.buscar.asObservable();

  private resetar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  resetar$ = this.resetar.asObservable();

  private produto = new Subject<ProdutoElement>();
  private atualizarImagemProduto: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setMinimizeMenu(val: boolean) {
    this.minimizeMenu.next(val);
  }

  setBuscar(data: any) {
    this.buscar.next(data);
  }

  setResetar(data: any) {
    this.resetar.next(data);
  }

  setProduto(val: ProdutoElement) {
    this.produto.next(val);
  }

  setAtualizarImagemProduto(val: boolean) {
    this.atualizarImagemProduto.next(val);
  }
}

export function determineDeviceType(): Observable<boolean> {
  const screenWidth = window.innerWidth;
  return of((screenWidth < 1024) ? true : false);
}
